const AI_READABLE_STOREFRONT_CAPABILITY = 'ai-readable-storefront'

export const showsSearchAndAi = ({ hasFullAccess, capabilities }) =>
  Boolean(hasFullAccess && capabilities.includes(AI_READABLE_STOREFRONT_CAPABILITY))
